(function($) {
    $(function() {
        $('#s').autocomplete({
            source: suggestSearch.ajaxurl + '?action=custom_suggest_search',
            delay: 250,
            minLength: 2
        });
    });
})(jQuery);
